export default __webpack_public_path__ + "static/media/camview-thumb2.d17b0bcc.webp";